require('./override.sass');

module.exports = {
  placeOrderTermsOfService: 'https://bredent-group.com/de/allgemeine-geschaeftsbedingungen/',
  api: {
    url: 'https://zeyos.bredent-group.com/de/remotecall/zeyos.portal.api/'
  },
  theme: 'dark',
  // colors: {
  //   primary: '#fff9c7',
  // },
  documentTitle: 'BREDENT ready4use Partner Shop',
  title: `<span class="logo">PARTNER SHOP</span>`,
  logo: require('./assets/BR-R4U-Logo_Negativ.png'),
  topMenu: [],
  cart: true,
  menu: [{
    name: 'shop',
    icon: 'store',
    main: true,
    title: 'Application.shop',
    component: () => import('./core/src/modules/Shop'),
    props: {
      categoryPicker: true,
      categoryImageBaseUrl: 'https://digital.bredent-group.com/img/category',
    }
  },{
    name: 'orders',
    icon: 'history',
    title: 'Application.orders',
    component: () => import('./core/src/modules/Transactions'),
    props: {
      type: 'orders',
      columns: [{
        field: "transactionnum",
        label: "Orders.orderNum",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
      }, {
        field: "netamount",
        label: "Common.netAmount",
        type: "num",
        align: "right",
      }, {
        field: "tax",
        label: "Common.taxAmount",
        type: "num",
        align: "right",
      }, {
        field: "total",
        label: "Common.total",
        type: "num",
        sortable: false,
        align: "right",
      }]
    }
  }, {
    name: 'billing',
    icon: 'attach_money',
    title: 'Application.invoices',
    pinProtected: false,
    component: () => import('./core/src/modules/Transactions'),
    props: {
      type: 'billing',
      columns: [{
        field: "transactionnum",
        label: "Invoices.invoiceNum",
      }, {
        field: "date",
        label: "Common.date",
        type: "date",
      }, {
        field: "netamount",
        label: "Common.netAmount",
        type: "num",
        align: "right",
      }, {
        field: "tax",
        label: "Common.taxAmount",
        type: "num",
        align: "right",
      }, {
        field: "total",
        label: "Common.total",
        type: "num",
        sortable: false,
        align: "right",
      }]
    }
  }]
}
